import axios from 'axios';
import axiosRetry from 'axios-retry';
import { standardRetryPolicy } from './axiosRetryPolicy';
export const createBareDocumentReference = (accessToken, fileUrl, tenant, deleteAfterDays) => {
    const deleteAfterDaysQuery = deleteAfterDays ? `&deleteAfterDays=${deleteAfterDays}` : '';
    const documentReference = {
        pdfUrl: fileUrl
    };
    const url = `/v1/uploads?tenant=${tenant}${deleteAfterDaysQuery}`;
    const baseUrl = 'https://uploads.documents.cimpress.io';
    const client = axios.create();
    axiosRetry(client, standardRetryPolicy);
    return client
        .post(url, documentReference, {
        baseURL: baseUrl,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    })
        .then(response => `${baseUrl}/v1/uploads/${response.data[0].uploadId}?tenant=${response.data[0].tenant}`);
};
export const uploadFile = (accessToken, file, tenant, provideThumbnails, deleteAfterDays) => {
    const process = JSON.stringify(provideThumbnails ? { type: 'image' } : { type: 'storeOnly' });
    const deleteAfterDaysQuery = deleteAfterDays ? `&deleteAfterDays=${deleteAfterDays}` : '';
    const formData = new FormData();
    formData.append(file.name, file);
    const url = `/v1/uploads/?process=${encodeURIComponent(process)}&tenant=${tenant}${deleteAfterDaysQuery}`;
    const baseUrl = 'https://uploads.documents.cimpress.io';
    const client = axios.create();
    axiosRetry(client, standardRetryPolicy);
    return client
        .post(url, formData, {
        baseURL: baseUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    })
        .then(response => {
        return Object.assign(Object.assign({}, response.data[0]), { _links: {
                self: {
                    href: `${baseUrl}/v1/uploads/${response.data[0].uploadId}?tenant=${response.data[0].tenant}`
                }
            } });
    })
        .catch(() => {
        const error = new Error('We are having trouble uploading your image file.');
        error.name = 'An error has occurred.';
        throw error;
    });
};
//# sourceMappingURL=uploads.js.map